const ColorsList = [
    {
        name:"White",
        value:"#ffffff",
        code:"62",
    },
    {
        name:"Slate Grey",
        value:"#90918c",
        code:"4",
    },
    {
        name:"Charcoal Grey",
        value:"#444445",
        code:"75",
    },
    {
        name:"Black",
        value:"#231f20",
        code:"xx",
    },
    {
        name:"Mauve",
        value:"#966077",
        code:"20",
    },
    {
        name:"Coral",
        value:"#d46a5c",
        code:"91",
    },
    {
        name:"Tangerine",
        value:"#f26722",
        code:"66",
    },
    {
        name:"Red",
        value:"#a61e22",
        code:"23",
    },
    {
        name:"Maroon",
        value:"#60182b",
        code:"48",
    },
    {
        name:"Citrus Yellow",
        value:"#f3e12f",
        code:"78",
    },
    {
        name:"Tan",
        value:"#825925",
        code:"12",
    },
    {
        name:"Sky Blue",
        value:"#8cbdd6",
        code:"16",
    },
    {
        name:"Electric Blue",
        value:"#0999d2",
        code:"32",
    },
    {
        name:"Royal Blue",
        value:"#283b88",
        code:"79",
    },
    {
        name:"Lavender",
        value:"#b196bf",
        code:"70",
    },
    {
        name:"Magenta",
        value:"#512048",
        code:"69",
    },
    {
        name:"Purple",
        value:"#492c63",
        code:"68",
    },
    {
        name:"OD Green",
        value:"#4c4533",
        code:"51",
    },
    {
        name:"Kelly Green",
        value:"#39a069",
        code:"71",
    },
    {
        name:"Forest Green",
        value:"#29543f",
        code:"73",
    },
    {
        name:"Khaki",
        value:"#b2af97",
        code:"5",
    },
    {
        name:"Pink",
        value:"#ed257f",
        code:"28",
    },
]


export default ColorsList




export const patternOptions = {
    "Radbows":" Rad Bows ",
    "Ammo_Cammo": " Ammo Cammo ",
    "Pineapple_Express": " Pineapple Express ",
    "Pink_Graffitti": " Pink Graffiti ",
    "Black_Camo": " Black Camo",
    "Green_Galaxy": " Green Galaxy ",
    "Purple_haze": " Purple Haze ",
    "Blue_Graffitti": " Blue Graffiti ",
    "Pink_Galaxy": " Pink Galaxy ",
    "Water_Color": " Water Color ",
    "Cammo": "  Cammo ",
    "Purple_Galaxy": " Purple Galaxy ",
    "Red_Haze": " Red Haze ",
    "Spring_Break": " Spring Break ",
    "Zombie_Unicorn_2": " Zombie Unicorn 2 ",
    "Stripes": " Stripes ",
    "Blue_Rock_Candy": " Blue Rock Candy ",
    "Sugar_Skull_2": " Sugar Skull 2 ",
    "Sugar_rush": " Sugar Rush ",
    "Red_Rockcandy": " Red Rock Candy",
    "Lemonade": " Lemonade"
}